import { ReactElement, useEffect } from 'react';
import useUrlParams from '../hooks/utility/useUrlParams';
import { UTMInterface } from '../services/exports/Interfaces';
import { ENVIRONMENTS } from '../services/exports/Constants';
import ReactPixel from 'react-facebook-pixel';
import useInitialData from '../hooks/global/useInitialData';
import ReduxActions from '../store/ReduxActions';
import { actionCreators } from '../store/actions';

interface Props {
  children: ReactElement;
}

export default function TrackingProvider({ children }: Props) {
  const params = useUrlParams();

  const { data } = useInitialData();
  const { franchise } = data;

  const utm: UTMInterface = {
    utm_source: params?.utm_source ?? document.referrer,
    utm_medium: params?.utm_medium,
    utm_campaign: params?.utm_campaign,
    utm_tracking_link_id: params?.utm_tracking_link_id,
    gclid: params?.gclid,
    fbclid: params?.fbclid,
  };

  const isAd = utm.gclid || utm.fbclid;
  const blacklist = ['paypal'];

  function saveUtm(): void {
    if (utm.utm_source && blacklist.some((item) => utm.utm_source.includes(item))) {
      return;
    }

    if (utm.utm_source || isAd) {
      ReduxActions.dispatch(actionCreators.tracking.setUtm(utm));
    }
  }

  useEffect(() => {
    saveUtm();
  }, []);

  useEffect(() => {
    if (franchise?.facebook_pixel_id) {
      ReactPixel.init(franchise.facebook_pixel_id, null, {
        autoConfig: true,
        debug: import.meta.env.VITE_MODE !== ENVIRONMENTS.PROD,
      });
      ReactPixel.pageView();
    }
  }, [franchise?.facebook_pixel_id]);

  return children;
}
